import React from 'react';

import { useGetTunnelMessagesQuery } from 'api/main';

import { BigLoader } from 'components';
import { PhasesNav } from 'containers/tunnel';
import { TunnelContainer, TunnelPhase } from 'containers/tunnel/common';
import { useTunnelPhases } from 'utils/hooks/tunnel';

const Onboarding = props => {
    const { lastPhaseIndex, roleName, phaseMemo, tunnelStepMemo, lastTunnelStepMemo } = props;

    const { isFetching: messagesLoader } = useGetTunnelMessagesQuery();
    const { phases, isLoading: listLoader } = useTunnelPhases();

    return listLoader || messagesLoader || !phaseMemo ? (
        <BigLoader />
    ) : (
        <TunnelContainer>
            <PhasesNav phases={phases} currentPhase={phaseMemo} lastPhaseIndex={lastPhaseIndex} />
            {!!phaseMemo && (
                <TunnelPhase
                    roleName={roleName}
                    tunnelStepMemo={tunnelStepMemo}
                    currentPhase={phaseMemo}
                    lastPhaseIndex={lastPhaseIndex}
                    lastTunnelStepMemo={lastTunnelStepMemo}
                />
            )}
        </TunnelContainer>
    );
};

export default Onboarding;
